import { main } from './main-module';

export const costCenters = {
  namespaced: true,
  modules: {
    main,
  },
};
